"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formConfig = {
  name: "comment",
  fields: {
    comment: {
      id: "citizen-comment",
      jsonPath: "actionInfo[0].comments",
      hintText: "CS_COMMON_COMMENTS_PLACEHOLDER2",
      value: "",
      required: true
    }
  },
  saveUrl: "/rainmaker-pgr/v1/requests/_update",
  redirectionRoute: ""
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/comment.js
// module id = ../lib/egov-ui-kit/config/forms/specs/pgr/comment.js
// module chunks = 504